"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clearToken;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
function clearToken() {
  console.log("useToken clearToken called");
  var event = new CustomEvent("trc-token-changed", {
    detail: null
  });
  document.dispatchEvent(event);
}